import React from 'react';

import { useParams } from 'react-router-dom';

import useClientContext from '../../contexts/ClientData/ClientData';
import useCommentContext from '../../contexts/CommentData/CommentData';
import useUserContext from '../../contexts/UserData/UserData';

import { getPipelineActivityData } from '../../ActivityLog/activity-utils';

import ActivityLog from '../../ActivityLog/ActivityLog';

const PipelineActivityLog = ({ pipeline }) => {
  const routeParams = useParams();
  const { isAuthEnabled } = useClientContext();
  const { userData } = useUserContext();
  const {
    comments,
    error,
    loading,
    canLoadMoreComments,
    addComment,
    updateComment,
    deleteComment,
    loadMoreComments,
  } = useCommentContext();

  if (!isAuthEnabled) {
    return null;
  }

  const activityData = getPipelineActivityData({
    comments,
    currentUser: userData,
    pipelineID: routeParams.id,
    pipelineCreatedAtDate: pipeline?.createdAt,
  })
  return (
    <div>
      <ActivityLog
        id="pipeline-activity-log"
        height={480}
        pipelineID={routeParams.id}
        pipelineVersion={routeParams.version}
        currentUser={userData}
        commentError={error}
        areCommentsLoading={loading}
        activityData={activityData}
        onAddComment={addComment}
        onUpdateComment={updateComment}
        onDeleteComment={deleteComment}
        canLoadMoreComments={canLoadMoreComments}
        onLoadMoreComments={loadMoreComments}
        disableScrollFading
      />
    </div>
  )
}

export default PipelineActivityLog;
